const fetchOpts = (req, res) => {
  if (res) {
    return {
      method: 'GET',
      headers: {
        cookie: req.headers['cookie']
      }
    };
  } else {
    return {
      method: 'GET',
      credentials: 'include'
    };
  }
};

export default fetchOpts;
